@if (value()) {
  @if (extraIconSvgName(); as icon) {
    <mat-icon class="!text-primary-lighter" [svgIcon]="icon" />
  } @else {
    <blaze-column-type-icon [columnType]="columnType()" [isArray]="isArray()" />
  }
}
